import React, { useCallback, useEffect, useState } from 'react';
import '../../Assets/Styles/offCanvas.css';
import { cartAddServiceTimeslot, checkValidCart, confirmBooking, getMyProfileDetails, getSearchFilter, serviceTimeSlotDetails, userSelectSearchLocation } from '../../Services/api';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
//firebase
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";

import axiosInstance from '../../Services/axios';
import OfferCard from '../../Pages/Offers/offercard';
import { toast } from 'react-toastify';
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import { FaArrowLeftLong } from "react-icons/fa6";
import VoiceSearchInput from '../VoiceSearchInput/VoiceSearchInput';
import VendorCategorieList from '../vendorcategories/vendorCategorieList';
import { showToast } from '../toastConfig/ToastConfig';
import NodeaxiosInstance from '../../Services/nodeaxios';


const OfferSearch = ({ }) => {

    const navigate = useNavigate();
    const [searchData, setSearchData] = useState("");
    const [offersDetailData, setOffersDetailData] = useState([]);
    const [merchantServiceId, setMerchantServiceId] = useState(0);
    const [latlong, setLatLong] = useState("");
    const [serviceTypeFilterData, setServiceTypeFilterData] = useState([])
    const [citySelectedVal, setCitySelectedVal] = useState("");
    const [apiSearchingDataLoader, setApiSearchingDataLoader] = useState(true);
    const [pageLoaded, setPageLoaded] = useState(false);
    const location = useLocation();
    const { from_Page } = location.state || {};
    const [inputSearchValue, setInputSearchValue] = useState("");
    const [showSearch, setShowsearch] = useState(false)
    const [categorieData, setCategorieData] = useState({
        vendor_type_id: null,
        vendor_category_id: null,
        vendor_type_name: "",
        vendor_category_name: "",
    });
    useEffect(() => {
        getFilterData()
    }, []);

    useEffect(() => {
        // API requires user location; wait until it is loaded from search filter
        if (!latlong) return;
        getOfferDetails()
    }, [latlong, merchantServiceId, searchData, categorieData, inputSearchValue])

    const getFilterData = async () => {
        try {
            const [response, locationRes] = await Promise.all([getSearchFilter(), userSelectSearchLocation()]);
            if (response?.status == 200) {
                const data = response?.data
                const selectedLocation = locationRes?.data?.selected_location
                setServiceTypeFilterData(data?.vendor_type || [])
                setLatLong(selectedLocation?.latlng || "")
                setCitySelectedVal(selectedLocation?.address || "");
                setPageLoaded(true)
                setApiSearchingDataLoader(true)
                // getOfferDetails()
                // setRecentSecarchOnOFF(false)

            }
        } catch (err) {
            console.error("getFilterData failed:", err);
            const status = err?.response?.status;
            if (!err?.response || status == 400 || status == 500) {
                showToast(err?.response?.data?.message || "Something went wrong, please try again later", "error");
            }
        }
    }

    const getOfferDetails = async () => {
        try {

            let params = {
                user_location: latlong,
                search_name: inputSearchValue,
                search_type: categorieData?.vendor_type_id || 0,
                search_category: '' // search vendor category
            }
            const response = await NodeaxiosInstance.post('/search-offer', params)
            const data = await response
            setOffersDetailData(response?.data?.search_results || [])
            setPageLoaded(true)

        } catch (error) {
            console.log(error);
        }
    }



    return (
        <div className='searchModal bg-white '>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button"
                        onClick={() => navigate(-1)} />

                    <div className="ff-balooPaaji2-bold fs-20 ms-1 ps-1">
                        Offers
                    </div>
                </div>

            </div>
            <div className='px-3 pt-2'>
                {/* <input type="search" className="ff-poppins-semiBold fs-16 w-100" placeholder="Search Membership" onChange={(event) => { setSearchData(event.target.value) }}/> */}

                <div className="">
                    <div onClick={() => setShowsearch(true)}>
                        <VoiceSearchInput
                            value={inputSearchValue}
                            setInputSearchValue={setInputSearchValue}
                            fromPage="offers"
                        />
                    </div>

                </div>
                <div className='  mt-3'>
                    <VendorCategorieList setCategorieData={setCategorieData} fromPage={'offerShipSearch'} />
                </div>
                {/* <div className="searchFilter scroller-style-x mt-4 mb-4">
                {serviceTypeFilterData && serviceTypeFilterData.map((item) => {
                    return (
                        <div className={(merchantServiceId == item.vendor_type_id ? "active " : " ") + "d-flex align-items-center"}
                            role="button"
                            onClick={() => {
                                setMerchantServiceId(item.vendor_type_id);
                            }}>
                            {item.vendor_type_name}
                        </div>);
                })}
            </div> */}
                <div className='scroller-style-y'>
                    <div style={{ marginBottom: "265px" }}>


                        {offersDetailData && offersDetailData.length ? offersDetailData.map((offer, index) => {

                            return (
                                <div className='p-0 m-0' onClick={() => {
                                    // if (offer.usage_limit_status == "1" && offer.usage_limit <= 0) {
                                    //     toast.error('You’ve reached the usage limit for this offer', {
                                    //         position: toast.POSITION.BOTTOM_CENTER
                                    //     });
                                    // } else if (offer.offer_used_count >= offer.usage_limit_per_user) {
                                    //     toast.error('Offer limit reached per user', {
                                    //         position: toast.POSITION.BOTTOM_CENTER
                                    //     });
                                    // } else {
                                    navigate(`/OfferDetails/${offer.vendor_id}/${offer.offer_id}`, { state: { offerid: offer.offer_id, vendorId: offer.vendor_id, categoryStatus: offer.applied_to_status, from_Page: "serarch_offer" } })
                                    // }
                                }}>
                                    <OfferCard key={index} data={offer} offer_from_Page="search" />
                                </div>
                            )
                        }) :
                            <div>
                                <Lottie animationData={empotyLottie} />
                                <div className='d-flex justify-content-center fs-12 ff-poppins-regular'>No Offers Available</div>
                            </div>
                        }
                    </div>
                    {/* <div style={{ height: 200 }}></div> */}
                </div>
            </div>
        </div>
    )
};

export default OfferSearch;